module.exports = __webpack_public_path__ + "img/eye.7ce9dcb2.svg";